import { cn } from '@/lib/utils';
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-gray-100 dark:bg-gray-800', className)} {...props} data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx" />;
}
export { Skeleton };